module.exports = __webpack_public_path__ + "img/4.26130d5f.jpg";